import { j as e } from "../../jsx-runtime-82a9ddf6.js";
import { useRef as k, useState as g, useEffect as w, useCallback as p } from "react";
import { useClickOutside as j } from "../../hooks/useClickOutside/index.js";
import { cva as _, cn as C } from "../../lib/cn.js";
/* empty css                    */const N = _(
  "px-2 min-h-[36px] cursor-pointer dark:hover:bg-slate-700 [&>a]:hover:text-slate-900 [&>a]:dark:hover:text-white dark:hover:text-white hover:text-slate-900 hover:bg-slate-100 rounded-md flex items-center justify-start gap-3",
  {
    variants: {
      variant: {
        active: "bg-slate-100 [&>a]:text-slate-900 [&>a]:dark:text-white text-slate-900 dark:bg-slate-700 dark:active:text-white",
        normal: "text-slate-500 [&>a]:text-slate-500"
      }
    }
  }
), E = ({ children: t, isHidden: r, isActive: s, className: l, onClick: o }) => r ? null : /* @__PURE__ */ e.jsx(
  "div",
  {
    onClick: o,
    className: C(l, N({ variant: s ? "active" : "normal" })),
    children: t
  }
), M = ({ autoClose: t, withAnimation: r = !0, skipCloseByClick: s, position: l, dropdownTrigger: o, dropdownFooter: d, dropdownHeader: c, className: u, wrapperClassName: h, children: f }) => {
  const m = k(null), [a, x] = g(!1);
  w(() => {
    t && i();
  }, [t]);
  const v = (n) => {
    n.target && n.target.onClick && n.target.onClick(), s || i();
  }, i = p(() => {
    x(!1);
  }, []), b = p(() => {
    x(!a);
  }, [a]);
  return j(m, i), /* @__PURE__ */ e.jsxs("div", { className: `${h} ${a ? "dropdown-menu-open" : ""} relative md:static`, ref: m, children: [
    /* @__PURE__ */ e.jsx("div", { onClick: b, children: o }),
    /* @__PURE__ */ e.jsxs("div", { className: `
    custom-animation font-medium text-base leading-4 text-slate-500
    absolute min-w-[260px] flex-col bg-white rounded-lg shadow-[0_4px_24px_-4px_rgba(18,20,23,.08)]
    ${l === "bottom" ? "top-[calc(100%+.5rem)]" : "bottom-[calc(100%+.5rem)]"} right-0 z-[999]
    dark:bg-slate-800 dark:shadow-[0px_0px_5px_0px_#000000a6]
    md:top-[100%] md:w-full
    ${u ?? ""}
    ${a ? `flex ${r ? "flipIn" : ""}` : "hidden"}`, children: [
      c ? /* @__PURE__ */ e.jsx("div", { className: "p-2 border-b border-slate-100 dark:border-slate-700", children: c }) : null,
      /* @__PURE__ */ e.jsx("div", { className: "p-2", onClick: v, children: f }),
      d ? /* @__PURE__ */ e.jsx("div", { className: "p-2 border-t border-slate-100 dark:border-slate-700", children: d }) : null
    ] })
  ] });
};
export {
  M as Dropdown,
  E as DropdownItem
};
